<template>
  <div>
    <money
      v-bind="money"
      :class="`my-custom-money${validar} my-custom-input${validar}`"
      v-model="novoValorProduto"
    ></money>
    <vs-button color="success" class="w-full mt-2" @click="processarNovoValor()"
      >Alterar</vs-button
    >
    <vs-alert
      v-if="validarVsAlert"
      title="Atenção!"
      active="true"
      color="danger"
      class="mt-2"
      style="height: auto !important"
      ><span
        >O valor atual não pode ser menor que o original
        {{ formataReal(valorProdutoOriginal || 0) }}</span
      ></vs-alert
    >
  </div>
</template>
<script>
import functions from '../../utils/functions';
import { Money } from 'v-money';

export default {
  name: 'FormNovoValorProduto',
  components: {
    Money,
  },
  props: ['produto', 'configValorMulti', 'veiculoIndex'],
  data() {
    const money = {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      suffix: '',
      precision: 2,
      masked: true,
    };

    return {
      money,
      produtoModificado: {},
      novoValorProduto: 0,
      valorProdutoOriginal: 0,
      formataReal: functions.formataReal,
      novoValorProdutoRateado: {},
    };
  },
  mounted() {
    if (this.configValorMulti) {
      if (this.configValorMulti.isMultiProposta) {
        this.preencheDadosMulti();
        return;
      }
    }
    this.preencheDados();
  },
  computed: {
    validar() {
      const validacao = this.verificaInferioridadeValorProdutoOriginal();
      return validacao ? '-danger' : '';
    },
    validarVsAlert() {
      return this.verificaInferioridadeValorProdutoOriginal();
    },
  },
  methods: {
    preencheDadosMulti() {
      const { valorTotalOriginal, valorTotal } = this.configValorMulti;
      this.valorProdutoOriginal = valorTotalOriginal;
      this.novoValorProduto = valorTotal;
    },
    preencheDados() {
      this.produtoModificado = this.produto;
      const { valor, valorOriginal } = this.produto;
      this.novoValorProduto = valor;
      this.valorProdutoOriginal = valorOriginal || valor;
      this.produtoModificado.valorOriginal = this.valorProdutoOriginal;
    },

    verificaInferioridadeValorProdutoOriginal() {
      let novoValorProduto = this.novoValorProduto;
      if (typeof novoValorProduto === 'string') {
        novoValorProduto = this.parsear(this.novoValorProduto);
      }

      if (novoValorProduto < this.valorProdutoOriginal) {
        return true;
      } else {
        return false;
      }
    },

    parsear(valor) {
      return parseFloat(
        valor.slice(3, valor.length).replace('.', '').replace(',', '.'),
      );
    },

    processarNovoValor() {
      const inferior = this.verificaInferioridadeValorProdutoOriginal();

      if (!inferior) {
        this.reatribuirNovoValorProduto();
        this.recalculadesconto();

        if (this.configValorMulti) {
          this.recalculaDescontoMulti();
        }

        this.$emit('produtoAtualizado', this.produto, this.veiculoIndex);
        this.$emit('atualizacaoConcluida');
        this.$emit('close');
      }
    },

    reatribuirNovoValorProduto() {
      if (typeof this.novoValorProduto === 'string') {
        this.novoValorProduto = this.parsear(this.novoValorProduto);
      }

      this.produtoModificado.valor = this.novoValorProduto;
    },

    recalculadesconto() {
      const { valor, descontoConcedido } = this.produtoModificado;
      const novoValorDesconto = valor * (descontoConcedido / 100);
      const novoValorFinal = valor * ((100 - descontoConcedido) / 100);

      this.produtoModificado.valorDesconto = novoValorDesconto;
      this.produtoModificado.valorFinal = novoValorFinal;
      this.produtoModificado.changeValorMinimoMensalidade = null;
    },

    recalculaDescontoMulti() {
      const { isMultiProposta, qtdProdutos, tipoValor, tipoVeiculo } =
        this.configValorMulti;
      const { valor, descontoConcedido } = this.produtoModificado;
      const novoValorDesconto = valor * (descontoConcedido / 100);
      const novoValorFinal = valor * ((100 - descontoConcedido) / 100);

      this.produtoModificado.valorDesconto = novoValorDesconto;
      this.produtoModificado.valorFinal = novoValorFinal;
      this.produtoModificado.changeValorMinimoMensalidade = null;

      if (isMultiProposta) {
        this.novoValorProdutoRateado = {
          valor,
          valorRateado: parseFloat((valor / qtdProdutos).toFixed(2)),
          valorDesconto: novoValorDesconto / qtdProdutos,
          valorFinal: novoValorFinal / qtdProdutos,
          changeValorMinimoMensalidade: null,
          tipoValor,
          tipoVeiculo,
          valorProdutoOriginal: this.valorProdutoOriginal,
        };
      }

      this.$emit('alteraValor', this.novoValorProdutoRateado);
    },
  },
};
</script>
<style>
.my-custom-money {
  font-size: 1.5em;
  color: #555555;
}
.my-custom-money-danger {
  font-size: 1.5em;
  color: #ea5455;
}
.my-custom-input {
  width: 100%;
  padding: 0.5em;
  border: 2px solid #b4b4b4;
  border-radius: 8px;
}
.my-custom-input-danger {
  width: 100%;
  padding: 0.5em;
  border: 2px solid #ea5455;
  border-radius: 8px;
}
</style>
